export default __webpack_public_path__ + "static/media/pizza-3.f2f9b9a4.jpg";